import { gql } from "@apollo/client";

export const InstalledBaseNodePath = gql`
    query InstalledBaseNodePath($id: ID!) {
        installedBaseNode(id: $id) {
            id
            title
            pathNodes {
                id
                title
            }
        }
    }
`;
